import React from 'react'

const ListadoProductosCombos = ({ item, baseUrl }) => {
    return (
        <div className="row cont_Atributos col-md-12 mb-2">
            <div className='col-4'><img className="w-100" src={baseUrl + 'productos/' + item.producto.imagePrev[0].nombre_imagen} alt={item.producto.nombre_producto} /></div>
            <div className='col'>
                <p className='p-0 m-0'>{item.producto.nombre_producto}</p>
                <AtributosProducto item={item} />
            </div>
        </div>
    )
}

const AtributosProducto = ({ item }) => {
    if (!item.atributos && !item.opciones && item.producto) return (
        <>
            <span>(x{item.cantidad}) {item.producto.nombre_producto} </span>
        </>
    )

    if (item.opciones.padre == 'Colores') return (
        <>
            <span>(x{item.cantidad}) {item.opciones.padre}: </span>
            <button type="button" key={item.opciones.color} className={`btn-colores-opciones   btn`} style={{ background: item.opciones.color }} />
        </>
    )

    return (
        <>
            <span>(x{item.cantidad}) {item.opciones.padre}: </span>
            <button type="button" key={item.opciones.nombre} className={` btn btn-sm producto-atributos-btn`}>{item.opciones.nombre}</button>
        </>
    )
}


export default ListadoProductosCombos